"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _CellTooltiped = _interopRequireDefault(require("./CellTooltiped"));

var _Cell = _interopRequireDefault(require("../Body/Cell"));

var _types = require("../utils/types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function CellLinked(props) {
  var value = _typeof(props) === 'object' ? props.value : props;
  var isLink = !!props.value && !!props.link;
  if (!isLink) return (0, _Cell.default)(value);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: props.link,
    className: "table-cell_linked"
  }, /*#__PURE__*/_react.default.createElement(_CellTooltiped.default, props));
}

CellLinked.propTypes = {
  value: _types.cellValue,
  link: _propTypes.default.string.isRequired
};
CellLinked.defaultProps = {
  value: null
};
var _default = CellLinked;
exports.default = _default;